import { render, staticRenderFns } from "./bandejaSolicitudesSaldo.vue?vue&type=template&id=07255833&scoped=true"
import script from "./bandejaSolicitudesSaldo.vue?vue&type=script&lang=js"
export * from "./bandejaSolicitudesSaldo.vue?vue&type=script&lang=js"
import style0 from "./bandejaSolicitudesSaldo.vue?vue&type=style&index=0&id=07255833&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07255833",
  null
  
)

export default component.exports